module.exports = __webpack_public_path__ + "img/w74b.0410bb36.jpg";